import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'fileName',
    standalone: false
})
@Injectable({
	providedIn: 'root',
})
export class FileNamePipe implements PipeTransform {

  transform(value: string): string {
    // erp_statements/2025-09-23/f87e7e85-c02b-4cbf-b3f6-705323609324-AP Invoices (1).csv
    //  => AP Invoices (1).csv
    if (typeof value !== 'string' || !value) {
      return '';
    }

    // Get the last segment, handling both "/" and "\\" separators
    const lastSegment = (value.split(/[\\\\\/]/).pop() || '').trim();

    // Remove a leading GUID (UUID) followed by a hyphen, if present
    const cleaned = lastSegment.replace(/^[0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}-/, '');

    return cleaned;
  }
}
